/* eslint-disable no-console */

import axios from 'axios';
import router from './router'
import {globalStore, vessels} from "./main.js"

export class getData {

    constructor(userProfile, getConstants) {
        if (typeof getConstants != 'undefined') {
            this.getConstants();
            this.getMapData();
        }
    }

    getConstants() {
        axios.get(globalStore.config.api_location + '/vessel/constants', {headers: {Authorization: globalStore.auth_token}}).then(response => {
            if (response.data.success) {
                globalStore.limits = response.data.data.limits;
                globalStore.mapping = response.data.data.mapping;
                globalStore.units = response.data.data.units;
                globalStore.faultMapping = response.data.data.faultParams;
            } else {
                globalStore.limits = {};
                globalStore.mapping = {};
                globalStore.units = {};
                globalStore.faultMapping = {};
            }
        });

        axios.get(`${globalStore.config.api_location}/availability/${(new Date()).getFullYear()}`, {headers: {Authorization: globalStore.auth_token}}).then(response => {
            let dates = {};

            Object.keys(response.data.data.dates).map((date_timestamp) => {
                dates[(new Date(parseInt(date_timestamp))).toISOString().split('T')[0]] = response.data.data.dates[date_timestamp];
            });

            globalStore.available_dates = dates
        });
    }

    async getDashboardData(date, dateTo) {
        var url = globalStore.config.api_location + '/shipco/dashboard/';

        if (typeof dateTo == 'string') {
            url += date + '/' + dateTo
        }

        axios.get(url, {headers: {Authorization: globalStore.auth_token}}).then((response) => {
            globalStore.dashboard = response.data.data;
        });
    }

    async getMapData() {
        axios.get(globalStore.config.api_location + '/vessel/map', {headers: {Authorization: globalStore.auth_token}}).then(response => {
            globalStore.mapData = response.data.data;
        });
    }

    async checkDate(date, imo, dateTo) {
        if (typeof date == 'undefined' || date.length < 1) {
            date = 'last';
        }

        document.body.style.cursor = 'progress';

        globalStore.checkedDate = false;
        globalStore.validDate = false;

        var checkFleetExistenceDataUrl = globalStore.config.api_location + '/checkFleetExistenceData/' + date;

        if (typeof dateTo == 'string') {
            checkFleetExistenceDataUrl = globalStore.config.api_location + '/checkFleetExistenceDataForRange/' + date + '/' + dateTo;
        }

        if (imo == '') {
            const response = await axios.get(checkFleetExistenceDataUrl, {headers: {Authorization: globalStore.auth_token}})
                .catch((e) => {
                    window.$cookies.set('login', 'Your connection to the application has expired');
                    globalStore.userLogged = false;
                    window.$cookies.remove('user');
                    location.reload(true);
                });

            if (response.status == 200) {
                if (typeof response.data.success != 'undefined' && !response.data.success) {
                    window.$cookies.set('login', 'Your connection to the application has expired');
                    globalStore.userLogged = false;
                    window.$cookies.remove('user');
                    setTimeout(() => {
                        location.reload(true);
                    }, 250);
                } else {
                    let tmp = response.data.data;

                    globalStore.availableVessels = [];

                    for (var key in tmp) {
                        if (tmp.hasOwnProperty(key) && !!tmp[key]) {
                            globalStore.availableVessels.push(key);
                        }
                    }

                    if (globalStore.availableVessels.length > 0) {
                        globalStore.validDate = true;
                        globalStore.checkedDate = true;
                        document.body.style.cursor = 'default';
                    } else {
                        globalStore.validDate = false;
                        globalStore.checkedDate = true;
                        document.body.style.cursor = 'default';
                    }
                }
            }
        } else {
            let response = await axios.get(checkFleetExistenceDataUrl, {headers: {Authorization: globalStore.auth_token}}).catch(() => {
                let logout = true;

                if ((date != 'last') && (date != 'today')) {
                    let dt = new Date(date);
                    let today = new Date();

                    if (dt >= today) logout = false
                }

                if (logout) {
                    window.$cookies.set('login', 'Your connection to the application has expired');
                    globalStore.userLogged = false;
                    window.$cookies.remove('user');
                    location.reload(true);
                } else {
                    globalStore.validDate = false;
                    globalStore.checkedDate = true;
                    document.body.style.cursor = 'default';
                }
            });

            if (response.status == 200) {
                if (typeof response.data.success != 'undefined' && !response.data.success) {
                    window.$cookies.set('login', 'Your connection to the application has expired');
                    globalStore.userLogged = false;
                    window.$cookies.remove('user');
                    setTimeout(() => {
                        location.reload(true);
                    }, 250);
                } else {
                    let tmp = response.data.data,
                        responseKeys = Object.keys(tmp);

                    globalStore.availableVessels = [];

                    for (let v = 0; v < responseKeys.length; v++) {
                        let key = responseKeys[v];

                        if (tmp[key])
                            globalStore.availableVessels.push(key);
                    }
                }
            }

            let url = globalStore.config.api_location + '/checkExistenceData/' + imo + '/' + date;

            if (typeof dateTo == 'string')
                url = globalStore.config.api_location + '/checkExistenceDataForDateRange/' + imo + '/' + date + '/' + dateTo;

            response = await axios.get(url, {headers: {Authorization: globalStore.auth_token}}).catch(() => {
                globalStore.validDate = false;
                globalStore.checkedDate = true;
                document.body.style.cursor = 'default';
            });

            if (response.status == 200) {
                if (response.data.data) {
                    globalStore.validDate = true;
                    globalStore.checkedDate = true;

                    globalStore.type = date;
                    globalStore.dateTo = dateTo;
                    document.body.style.cursor = 'default';
                } else {
                    globalStore.validDate = false;
                    globalStore.checkedDate = true;
                    document.body.style.cursor = 'default';
                }
            }
        }

        globalStore.type = date;
        globalStore.dateTo = dateTo;
    }

    async getData(date, imo, dateTo) {
        document.body.style.cursor = 'progress';

        globalStore.type = '';
        globalStore.dateTo = '';

        if (!!!date) {
            date = 'last';
        }

        if (imo != '') {
            var url = globalStore.config.api_location + '/vessel/GetVesselInfo/' + imo + '/' + date;

            if (typeof dateTo == 'string') {
                url += '/' + dateTo;
            }

            await axios.get(url, {headers: {Authorization: globalStore.auth_token}}).then(async response => {
                try {
                    globalStore.loadDiagram = response.data.data['load_diagram'];

                    this.parseShopData(response.data.data['shop_test_data']);

                    if (globalStore.twinEngine) {
                        var has_twin = Object.values(vessels.vessels).filter(i => {
                                return i.imo == imo;
                            })[0].has_twin,
                            segmentedData = has_twin && typeof dateTo == 'string';

                        if (segmentedData) {
                            try {
                                var indexes = ['signal', 'reference', 'faults'];
                                for (var i in indexes) {
                                    if (indexes.hasOwnProperty(i)) {
                                        await axios.get(url + '/' + indexes[i], {headers: {Authorization: globalStore.auth_token}}).then(response => {
                                            switch (indexes[i]) {
                                                case 'signal':
                                                    globalStore.twinSignals = response.data.data.signal;
                                                    break;
                                                case 'reference':
                                                    globalStore.twinReference = response.data.data.reference;
                                                    break;
                                                case 'faults':
                                                    globalStore.twinFaults = response.data.data.faults;
                                                    break;
                                            }
                                        });
                                    }
                                }
                            } catch (e) {
                                console.log(e)
                            }
                        } else {
                            globalStore.twinSignals = response.data.data.signal;
                            globalStore.twinReference = response.data.data.reference;
                            globalStore.twinFaults = Object.assign({}, response.data.data.faults);
                        }

                        globalStore.twinFaults = {
                            'Port': (globalStore.twinFaults.Port
                                    ? Object.values(globalStore.twinFaults.Port).map(function (item) {
                                        return (typeof item == 'string' ? JSON.parse(item) : item);
                                    })
                                    : []
                            ),
                            'Stbd': (globalStore.twinFaults.Stbd
                                    ? Object.values(globalStore.twinFaults.Stbd).map(function (item) {
                                        return (typeof item == 'string' ? JSON.parse(item) : item);
                                    })
                                    : []
                            )
                        };
                        
                        Object.keys(globalStore.twinSignals).forEach(engine=> globalStore.twinSignals[engine] = this.correctMEPowerSignals(globalStore.twinSignals[engine]))

                        globalStore.twinFaults.Port = globalStore.twinFaults.Port.filter(fault => {
                            let code = fault.events[0].code;

                            return !globalStore.config.disabled_rules.some(item => code.startsWith(item));
                        })

                        globalStore.twinFaults.Stbd = globalStore.twinFaults.Stbd.filter(fault => {
                            let code = fault.events[0].code;

                            return !globalStore.config.disabled_rules.some(item => code.startsWith(item));
                        })

                        if (globalStore.selectedEngine != '') {
                            if (globalStore.selectedEngine in globalStore.twinSignals) {
                                globalStore.signals = globalStore.twinSignals[globalStore.selectedEngine];
                                globalStore.reference = globalStore.twinReference[globalStore.selectedEngine];
                                globalStore.faults = globalStore.twinFaults[globalStore.selectedEngine];
                            } else {
                                router.push({path: '/vessel-view/' + globalStore.selectedVessel});       //router.history.current.params.vessel
                            }
                        }
                    } else {
                        globalStore.signals = this.correctMEPowerSignals(response.data.data.signal);
                        globalStore.reference = response.data.data.reference;

                        if (response.data.data.name) {
                            globalStore.selectedVessel = response.data.data.name;
                        }

                        this.parseFaults(response.data.data.faults/*, companyFilter*/);
                    }

                    globalStore.hasACKMaintenanceTasks = response.data.data.ack_maintenance_tasks;

                    globalStore.MyEvent.fire('vesselDataLoaded');
                } catch (e) {
                    console.log(e);
                    globalStore.loadDiagram = {};
                    globalStore.signals = {};
                    globalStore.reference = {};
                    globalStore.twinSignals = {};
                    globalStore.twinReference = {};
                    globalStore.faults = [];
                    globalStore.chartData = {};
                }
            });

            globalStore.type = date;
            globalStore.dateTo = dateTo;
        } else {
            this.getDashboardData(date, dateTo);

            globalStore.type = date;
            globalStore.dateTo = dateTo;
        }

        document.body.style.cursor = 'default';
    }

    correctMEPowerSignals(signals)
    {
        let mcr = globalStore.loadDiagram['otVal1'];   
        
        signals.timestamps.forEach(timestamp=>
        {           
            if (signals[timestamp]['load']!=-1000)
                signals[timestamp]['ME_Power_perc'] = signals[timestamp]['load'] * 100;   
            else           
                signals[timestamp]['ME_Power_perc'] = -1000;
            

            if (signals[timestamp]['load']!=-1000)
                signals[timestamp]['ME_Power_kW'] = signals[timestamp]['load']  * mcr; 
            else 
                signals[timestamp]['ME_Power_kW'] = -1000;
        })

        if ('average' in signals)
        {
            if (signals['average']['load']!=-1000)
                signals['average']['ME_Power_perc'] = signals['average']['load'] * 100;   
            else        
                signals['average']['ME_Power_perc'] = -1000;
            

            if (signals['average']['load']!=-1000)
                signals['average']['ME_Power_kW'] = signals['average']['load']  * mcr; 
            else 
                signals['average']['ME_Power_kW'] = -1000;
        }

        return signals;
    }

    async checkYearAvailability(year) {
        axios.get(`${globalStore.config.api_location}/availability/${year}`, {headers: {Authorization: globalStore.auth_token}}).then(response => {
            let dates = {};

            Object.keys(response.data.data.dates).map((date_timestamp) => {
                dates[(new Date(parseInt(date_timestamp))).toISOString().split('T')[0]] = response.data.data.dates[date_timestamp];
            });

            globalStore.available_dates = Object.assign(dates, globalStore.available_dates);
        });
    }

    parseFaults(faultsTmp/*, companyFilter*/) {
        var data = faultsTmp;

        if (typeof data['Port'] != 'undefined')
            data = data['Port'];

        let faultDict = data;

        if (faultDict.length) {
            var faults = faultDict.map(function (item) {
                if (typeof item != 'object') {
                    item = JSON.parse(item);
                }

                item.startDate = item.startDate.replace('T', ' ');
                item.endDate = item.endDate.replace('T', ' ');

                return item;
            });

            faults = faults.sort(function (a, b) {
                return new Date(a.endDate) - new Date(b.endDate);
            });

            //if (companyFilter)
            faults = faults.filter(fault => {
                let code = fault.events[0].code;
                return !globalStore.config.disabled_rules.some(item => code.startsWith(item));
            })

            globalStore.faults = faults;
        } else
            globalStore.faults = [];
    }

    parseShopData(shop_test_data) {
        if (globalStore.twinEngine) {
            shop_test_data = shop_test_data['Port'];
        }

        let keys = Object.keys(shop_test_data),
            elementNo = shop_test_data.elementNo;
        
        keys.splice(keys.indexOf('elementNo'), 1);

        for (let i = 0; i < keys.length; i++) {
            globalStore.chartData[keys[i]] = shop_test_data[keys[i]];
        }

        globalStore.cylCount = elementNo.cylNo;
        globalStore.tcCount = elementNo.tcNo;
    }

    checkEngineStatus(signals) {
        let timestamp = signals['lastDate'];

        if (signals[timestamp]) {
            let stateText = signals[timestamp]['engineStateText'];
            if (stateText == undefined) {
                // if (signals[timestamp]['engineState'] == -1000)
                //     router.push({path: 'dashboard'});
            } else {
                if ((stateText != 'Running') && (stateText != 'Slowdown'))
                    router.push({path: 'dashboard'});
            }
        }
    }

    getCookieData(name) {
        var patrn = new RegExp("^" + name + "=(.*?);"),
            patr2 = new RegExp(" " + name + "=(.*?);");
        let match = (document.cookie.match(patrn) || document.cookie.match(patr2));
        if (match)
            return match[1];
        return false;
    }

    async getUserNotifications() {
        axios.get(`${globalStore.config.api_location}/alerts/`, {headers: {Authorization: globalStore.auth_token}}).then(async response => {
            try {
                await localStorage.setItem('alerts', JSON.stringify(response.data.data));
                globalStore.alerts = response.data.data;
            } catch (e) {
            }
        }).catch((e) => {
        });
    }
}